import { MODEL_VERSION } from '@/app/constants';
import type { ReferencePrompt } from '@/app/types';
import { getReferenceMediaDropArgs } from './reference-model-capabilities';

/**
 * Q2 Pro reference video upload limits shared by create pages and home entry.
 *
 * 额度规则见 `reference-model-capabilities.ts` 的 capability table。
 */
export function getQ2CharVideoMediaDropArgs(
  referencePrompts: ReferencePrompt[],
  options?: {
    minVideoDuration?: number;
    maxVideoDuration?: number;
  },
): ReturnType<typeof getReferenceMediaDropArgs> {
  return getReferenceMediaDropArgs(MODEL_VERSION.Q2_PRO, referencePrompts, options);
}
